import React from 'react';

export default ({ bold, gray, children, ...props }) => {
    return (<div className={`event-info-line`}>
        <span className={`zt-p1 ${bold ? 'bold': ''} ${gray ? 'gray': ''}`}>{children}</span>
    </div>)
}